var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{class:`spinner-wrapper ${_vm.fullscreen ? 'fullscreen' : ''}`,attrs:{"aria-live":"polite","aria-busy":"true"}},[_c('div',{staticClass:"spinner",attrs:{"role":"status","aria-label":"Cargando"}}),(_vm.showText)?_c('h3',[_vm._v("Aguarde un momento...")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }